/** Where a screen puts its header action on a phone, such as a list's refresh button. */
export const HEADER_SLOT_ID = 'shell-header-slot';
